import { Component } from '@angular/core';

@Component({
  selector: 'wfc-splash-screen',
  templateUrl: 'splash-screen.component.html'
})
export class SplashScreenComponent {

}
